import { Flex, Progress } from "antd";
import { FC } from "react";

import { PrimaryText } from "@/components/Typography/Styled";

interface ProgressLoadingProps {
    completedCount: number;
    totalCount: number;
}

export const ProgressLoading: FC<ProgressLoadingProps> = ({
    completedCount,
    totalCount,
}) => {
    return (
        <Flex vertical gap={8}>
            <Progress
                percent={Math.ceil((completedCount / totalCount) * 100)}
                status="active"
            />

            <PrimaryText>
                Завантажено {completedCount} фото із {totalCount}
            </PrimaryText>
        </Flex>
    );
};
